interface VEditorPreviewProps {
  html: string;
}

export default function VEditorPreview({ html }: VEditorPreviewProps) {
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
